import React from 'react';
import PropTypes from 'prop-types';
import { ArticleWrapper, ArticleImage, ArticleTitle } from './styles';

export default function Online(props) {
	return <ArticleWrapper>
		<a href={props.link}>
			<ArticleImage src={props.image} width="65" height="65" />
			<ArticleTitle>{props.title}</ArticleTitle>
		</a>
	</ArticleWrapper>
}

Online.propTypes = {
	link: PropTypes.string.isRequired,
	title: PropTypes.string.isRequired,
	image: PropTypes.string.isRequired
};
